import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Flex } from '@radix-ui/themes';

import { Footer } from '../../../layout/footer/Footer';
import { MenuButtonsList } from '../../../components/menuButton/MenuButtonsList';
import { Page, TransitionUrl, TranslationPath } from '../../../contexts/kioskConfiguration/type';
import useLanguage from '../../../contexts/language/LanguageContext';
import { getTranslationByPath } from '../../../utils/translations';
import {
  setFetchedTransportation, setTransportationForm,
  setTransportationType, transportationFormInitialState
} from '../../../store/slices/transportation/transportationSlice';
import { MainContent } from '../../../layout/content/MainContent';
import { setSelectedPage } from '../../../store/slices/app/appSlice';


export type TransportationTypesTemplateType = {
  label: string
  buttons: {
    label: TranslationPath
    transitionUrl: TransitionUrl
  }[]
}

type Props = {
  page: Page<TransportationTypesTemplateType>
}

export const TransportationTypesTemplate = (props: Props): React.ReactElement => {
  const language = useLanguage()
  const dispatch = useDispatch()

  return (
    <div>
      <MainContent>
        <div className="text-center mb-10">
          {getTranslationByPath(language.translations, props.page.data.label)}
        </div>
        <Flex direction="column" gap="1" width="100%" className="items-center">
          <Box maxWidth="500px" className="w-full flex flex-col items-center text-center">

            <MenuButtonsList buttons={props.page.data.buttons.map((b: any) => {
              return {
                label: getTranslationByPath(language.translations, b.label),
                onClick: () => {
                  dispatch(setTransportationType(b.transportationTypeId))
                  dispatch(setFetchedTransportation(null))
                  dispatch(setTransportationForm({
                    ...transportationFormInitialState,
                  }))
                  dispatch(setSelectedPage(b.transitionUrl))
                },
              }
            })} />
          </Box>
        </Flex>
      </MainContent>
      <Footer backUrl={props.page.footer?.back} />
    </div>
  )
}
